import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import style from "./style.module.scss";
import Header from "../header";
import { getProductType } from "../../../../product";
import { requireLogin } from "../../../../security";
import { productQueryOptions, useSaveProductMutation } from "../../../../data/queries/products";
import { Spinner } from "../../../../ui";

function AdminProductEdit() {
  const { uid } = useParams();
  const { data: product, isLoading } = useQuery(productQueryOptions(uid || ""));
  const saveMutation = useSaveProductMutation();

  const breadcrumbItems = [
    { label: "Admin", link: "/admin" },
    { label: `Product ${uid}`, link: `/admin/${uid}` },
    { label: "Edit" },
  ];

  const setOptions = (newOptions: Record<string, unknown>) => {
    if (!product) return;

    saveMutation.mutate({
      product: {
        ...product,
        options: {
          ...product.options,
          ...newOptions,
        },
      },
      // Use product's userId, not the admin's ID
      userId: product.userId,
    });
  };

  if (isLoading || !product) {
    return <Spinner />;
  }

  const productType = getProductType(product.name);
  if (!productType) {
    return <Spinner />;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Settings = productType.settings as React.ComponentType<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Edit = productType.edit as React.ComponentType<any>;

  return (
    <section className={style.adminEdit}>
      <div className={style.header}>
        <Header breadcrumbItems={breadcrumbItems} />
      </div>
      <div className={style.content}>
        <div>
          <h2 className={style.sectionTitle}>Couverture</h2>
          <Settings
            productId={product.uid}
            userId={product.userId}
            options={product.options}
            setOptions={setOptions}
          />
          <h2 className={style.sectionTitle}>Pages</h2>
          <Edit
            productId={product.uid}
            userId={product.userId}
            options={product.options}
            setOptions={setOptions}
          />
        </div>
      </div>
    </section>
  );
}

export default requireLogin({ role: "admin" })(AdminProductEdit);
